import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import MoveToCategory from '../../components/move-to-category';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

const MovePostModal = ({ categories, move, closeModal, categoryId, t }) =>
  <Modal onClose={closeModal}>
    <MoveToCategory
      categories={categories}
      currentCategoryId={categoryId}
      onClick={move}
      onCancel={closeModal}
      message={t('move-post-modal.move-this-post')}
    />
  </Modal>;

MovePostModal.propTypes = {
  move: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  categoryId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  categories: state.categories,
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      move: categoryId => closeModal({ categoryId, postId: ownProps.postId }),
      closeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(MovePostModal));



// WEBPACK FOOTER //
// ./app/containers/move-post-modal/move-post-modal.js